import React, { useEffect, useState } from 'react';
import { GetApiHandler } from '../utils/Api';

const getTodayDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const UpdateModal = ({
  open,
  onClose,
  onDateSelect,
  onApply,
  initialCityId = '',
  initialLocationId = '',
  initialDate = '',
}) => {
  const [cities, setCities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const minDate = getTodayDateString();

  useEffect(() => {
    const load = async () => {
      try {
        const [citiesRes, locationsRes] = await Promise.all([
          GetApiHandler({}, 'cities'),
          GetApiHandler({}, 'locations'),
        ]);
        setCities(Array.isArray(citiesRes?.data) ? citiesRes.data : []);
        setLocations(Array.isArray(locationsRes?.data) ? locationsRes.data : []);
      } catch (err) {
        console.error('Failed to load cities/locations', err);
      }
    };

    if (open) {
      setSelectedCity(initialCityId || '');
      setSelectedLocation(initialLocationId || '');
      setSelectedDate(initialDate && initialDate >= minDate ? initialDate : '');
      load();
    }
  }, [open, initialCityId, initialLocationId, initialDate, minDate]);

  if (!open) return null;

  const filteredLocations = selectedCity
    ? locations.filter((loc) => `${loc.city_id}` === `${selectedCity}`)
    : locations;

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal-card">
        <div className="modal-header">
          <h4 className="modal-title">Update Details</h4>
          <button className="modal-close" type="button" onClick={onClose} aria-label="Close">
            X
          </button>
        </div>

        <div className="modal-body">
          <label className="field">
            <span className="field-label">City</span>
            <div className="field-control">
              <select
                value={selectedCity}
                onChange={(e) => {
                  setSelectedCity(e.target.value);
                  setSelectedLocation('');
                }}
              >
                <option value="" disabled>
                  Select a city
                </option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
              <i className="bi bi-chevron-down field-icon" />
            </div>
          </label>

          <label className="field">
            <span className="field-label">Location</span>
            <div className="field-control">
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
              >
                <option value="" disabled>
                  Choose a location
                </option>
                {filteredLocations.map((loc) => (
                  <option key={loc.id} value={loc.id}>
                    {loc.name}
                  </option>
                ))}
              </select>
              <i className="bi bi-chevron-down field-icon" />
            </div>
          </label>

          <label className="field">
            <span className="field-label">Date</span>
            <div className="field-control">
              <input
                type="date"
                min={minDate}
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value);
                  if (e.target.value && onDateSelect) {
                    onDateSelect(e.target.value);
                  }
                }}
              />
              <i className="bi bi-calendar-date field-icon" />
            </div>
          </label>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              const city = cities.find((item) => `${item.id}` === `${selectedCity}`);
              const location = locations.find((item) => `${item.id}` === `${selectedLocation}`);

              onApply?.({
                cityId: selectedCity,
                locationId: selectedLocation,
                showDate: selectedDate,
                cityName: city?.name || '',
                locationName: location?.name || '',
              });
            }}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateModal;
